import axios from 'axios';
import { APP_SETTINGS } from '../../config';

export function getAllInvoices() {
    return axios.post(APP_SETTINGS.API_PATH.INVOICE.getInvoice);
}

export function addNewInvoice(invoiceData) {
    return axios.post(APP_SETTINGS.API_PATH.INVOICE.addInvoice, invoiceData);
}

export function removeInvoice(invoiceId) {
    var data = {
        "invoiceId": invoiceId
    }
    return axios.post(APP_SETTINGS.API_PATH.INVOICE.removeInvoice, data)
}